import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {extractListResponse, handleResponseError, ListResponse} from '../common/api-helpers';
import {CommonListFilterQueryParamsFactory} from '../factories/common-list-query-params.factory';
import {CommonListFilter} from '../models/filters/common-list-filter';
import {UserSession} from '../models/user-session';
import {AppConfigService} from './config.service';

@Injectable()
export class BackofficeUserSessionService {

    private userSessionsUrl: string = this.appConfigService.api['backofficeUserSessions'];

    constructor(
        private httpClient: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    public getUserSessions(filter: CommonListFilter): Observable<ListResponse<UserSession>> {
        let requestParams: HttpParams;

        if (filter) {
            const params = CommonListFilterQueryParamsFactory.createQueryParamsAsString(filter);
            requestParams = new HttpParams({fromString: params});
        }

        return this.httpClient.get<ListResponse<UserSession>>(this.userSessionsUrl, {params: requestParams}).pipe(
            map(extractListResponse),
            catchError(handleResponseError)
        );
    }

    public getUserSession(sessionId: string): Observable<UserSession> {
        return this.httpClient.get<UserSession>(`${this.userSessionsUrl}/${sessionId}`).pipe(
            catchError(handleResponseError)
        );
    }
}
